var React = require('react');

function Play (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M485 370c-5 24-25 42-50 45a1299 1299 0 01-359 0c-25-3-46-21-50-45a644 644 0 010-228c4-24 25-42 50-45a1299 1299 0 01359 0c25 3 45 21 50 45a624 624 0 010 228","fill":"red","key":0}),React.createElement("path",{"fill":"#fff","d":"M176 176l160 80-160 80z","key":1})]);
}

Play.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Play;

Play.default = Play;
